'use client';

import type { PropsWithChildren } from 'react';
import { useIsLoggedIn, useUser } from '@tv2/lib-offspring/api/user/UserProvider';
import Sticky from '@tv2-cas/offspring/navigation/Sticky';
import { Navigation } from '@tv2-cas/offspring/navigation/Navigation';

/**
 * Navigation chrome for the root `error.tsx` / `not-found.tsx` boundaries. These
 * render outside the `(app)/(main)` layout (they can be triggered before/at the
 * root), so they can't inherit the persistent navigation and render their own.
 */
export function ErrorPageChrome({ children }: PropsWithChildren) {
  const { completed } = useUser();
  const isLoggedIn = useIsLoggedIn();
  const showMenu = completed && isLoggedIn;
  const showLogin = completed && !isLoggedIn;

  return (
    <>
      <Sticky>
        <Navigation showMenu={showMenu} showLogin={showLogin} />
      </Sticky>
      {children}
    </>
  );
}
